<template>
  <div
    id="game-ui"
    class="game-ui fade-in"
    v-if="!hideUi"
    :class="{ shown: isData }"
  >
    <div
      @endSound="finishedIntroSound()"
      :id="isNotEnglish"
      v-if="
        showIntro &&
          !hideUi &&
          isData &&
          !isLevelOne &&
          getBeltColor == 'white' &&
          isIdentifyNoOfLevel == 'two'
      "
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_3_19')"
    ></div>
    <div
      @endSound="finishedIntroSound()"
      :id="isNotEnglish"
      v-if="
      isFirstTimeAppearShVaWithContent &&
        showIntro &&
          !hideUi &&
          isData &&
          !isLevelOne &&
          getBeltColor == 'white' &&
          (isIdentifyNoOfLevel == 'three' || isIdentifyNoOfLevel == 'four')
      "
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      class="whiteContentfor1"
      v-html="$t('homePageTexts.animationGen_3_24')"
    ></div>
    <div
     @load="imgLoadHandler()"
     :id="isNotEnglish"
      v-if="
        isChooseImagesActive &&
        isShowPics &&
          !showIntro &&
          getBeltColor == 'white' &&
          (isIdentifyNoOfLevel == 'three' ||
            isIdentifyNoOfLevel == 'four' ||
            isIdentifyNoOfLevel == 'five')
      "
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_white_ChooseOptionOfImage_3_30')"
    ></div>

    <div
     @load="imgLoadHandler()"
     :id="isNotEnglish"
      v-if="
        isChoosenAnswerWords &&
        isShowPics &&
          !showIntro &&
          getBeltColor == 'white' &&
          (isIdentifyNoOfLevel == 'three' ||
            isIdentifyNoOfLevel == 'four' ||
            isIdentifyNoOfLevel == 'five')
      "
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t(soundContent)"
    ></div>

    <div
      @endSound="finishedIntroSound()"
      @load="imgLoadHandler()"
      :id="isNotEnglish"
      v-if="
        isChooseImagesActive &&
        showIntro &&
          !hideUi &&
          isData &&
          !isLevelOne &&
          getBeltColor == 'white' &&
          isIdentifyNoOfLevel == 'six'
      "
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_white_six_chooseImage_3_26')"
    ></div>
    <!-- <div v-if="getBeltColor=='white' && isIdentifyNoOfLevel=='three' || isIdentifyNoOfLevel=='four'" style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;" class="whiteContentfor1" v-html="$t('homePageTexts.animationGen_3_24')"></div> -->
    <div
      @endSound="finishedIntroSound()"
      :id="isNotEnglish"
      v-if="
        showIntro &&
          !hideUi &&
          isData &&
          !isLevelOne &&
          (getBeltColor == 'white' ||
            getBeltColor == 'orange' ||
            getBeltColor == 'green' ||
            getBeltColor == 'yellow' ||
            getBeltColor == 'blue') &&
          isIdentifyNoOfLevel == 'five'
      "
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_3_25')"
    ></div>

    <!-- Yellow -->

    <div
      @endSound="finishedIntroSound()"
      :id="isNotEnglish"
      v-if="
        showIntro &&
          !hideUi &&
          isData &&
          !isLevelOne &&
          getBeltColor == 'yellow' &&
          isIdentifyNoOfLevel == 'two'
      "
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGenYellow_3_20')"
    ></div>
    <div
      @endSound="finishedIntroSound()"
      :id="isNotEnglish"
      v-if="
      isFirstTimeAppearShVaWithContent &&
        showIntro &&
          !hideUi &&
          isData &&
          !isLevelOne &&
          getBeltColor == 'yellow' &&
          (isIdentifyNoOfLevel == 'three' ||
            isIdentifyNoOfLevel == 'four')
      "
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      class="whiteContentfor1"
      v-html="$t('homePageTexts.animationGen_3_24')"
    ></div>
    
    <div
     @load="imgLoadHandler()"
     :id="isNotEnglish"
      v-if="
        isChooseImagesActive &&
        isShowPics &&
          !showIntro &&
          getBeltColor == 'yellow' &&
          (isIdentifyNoOfLevel == 'three' ||
            isIdentifyNoOfLevel == 'four' ||
            isIdentifyNoOfLevel == 'five' ||
            isIdentifyNoOfLevel == 'six')
      "
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_white_ChooseOptionOfImage_3_30')"
    ></div>
    <div
      @endSound="finishedIntroSound()"
      @load="imgLoadHandler()"
      :id="isNotEnglish"
      v-if="
        isChooseImagesActive &&
        showIntro &&
          !hideUi &&
          isData &&
          !isLevelOne &&
          getBeltColor == 'yellow' &&
          isIdentifyNoOfLevel == 'six'
      "
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_white_six_chooseImage_3_26')"
    ></div>

    <!-- Orange -->

    <div
      @endSound="finishedIntroSound()"
      :id="isNotEnglish"
      v-if="
        showIntro &&
          !hideUi &&
          isData &&
          !isLevelOne &&
          getBeltColor == 'orange' &&
          isIdentifyNoOfLevel == 'two'
      "
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGenOrange_3_21')"
    ></div>
    <div
      @endSound="finishedIntroSound()"
      :id="isNotEnglish"
      v-if="
      isFirstTimeAppearShVaWithContent &&
        showIntro &&
          !hideUi &&
          isData &&
          !isLevelOne &&
          getBeltColor == 'orange' &&
          (isIdentifyNoOfLevel == 'three' || isIdentifyNoOfLevel == 'four')
      "
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      class="whiteContentfor1"
      v-html="$t('homePageTexts.animationGen_3_24')"
    ></div>
    <div
      @load="imgLoadHandler()"
      :id="isNotEnglish"
      v-if="
        isChooseImagesActive &&
        isShowPics &&
          !showIntro &&
          getBeltColor == 'orange' &&
          (isIdentifyNoOfLevel == 'three' ||
            isIdentifyNoOfLevel == 'four' ||
            isIdentifyNoOfLevel == 'five' ||
            isIdentifyNoOfLevel == 'six')
      "
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_white_ChooseOptionOfImage_3_30')"
    ></div>
    <div
      @endSound="finishedIntroSound()"
      @load="imgLoadHandler()"
      :id="isNotEnglish"
      v-if="
       isChooseImagesActive &&
        showIntro &&
          !hideUi &&
          isData &&
          !isLevelOne &&
          getBeltColor == 'orange' &&
          isIdentifyNoOfLevel == 'six'
      "
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_white_six_chooseImage_3_26')"
    ></div>

    <!-- Green -->
    <div
      @endSound="finishedIntroSound()"
      :id="isNotEnglish"
      v-if="
        showIntro &&
          !hideUi &&
          isData &&
          !isLevelOne &&
          getBeltColor == 'green' &&
          isIdentifyNoOfLevel == 'two'
      "
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_green_3_22')"
    ></div>
    <div
      @endSound="finishedIntroSound()"
      :id="isNotEnglish"
      v-if="
      isFirstTimeAppearShVaWithContent &&
        showIntro &&
          !hideUi &&
          isData &&
          !isLevelOne &&
          getBeltColor == 'green' &&
          (isIdentifyNoOfLevel == 'three' || isIdentifyNoOfLevel == 'four')
      "
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      class="whiteContentfor1"
      v-html="$t('homePageTexts.animationGen_3_24')"
    ></div>
    <div
      @load="imgLoadHandler()"
      :id="isNotEnglish"
      v-if="
      isChooseImagesActive &&
        isShowPics &&
          !showIntro &&
          getBeltColor == 'green' &&
          (isIdentifyNoOfLevel == 'three' ||
            isIdentifyNoOfLevel == 'four' ||
            isIdentifyNoOfLevel == 'five' ||
            isIdentifyNoOfLevel == 'six')
      "
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_white_ChooseOptionOfImage_3_30')"
    ></div>
    <div
      @endSound="finishedIntroSound()"
      @load="imgLoadHandler()"
      :id="isNotEnglish"
      v-if="
      isChooseImagesActive &&
        showIntro &&
          !hideUi &&
          isData &&
          !isLevelOne &&
          getBeltColor == 'green' &&
          isIdentifyNoOfLevel == 'six'
      "
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_white_six_chooseImage_3_26')"
    ></div>

    <!-- Blue  -->
    <div
      @endSound="finishedIntroSound()"
      :id="isNotEnglish"
      v-if="
        showIntro &&
          !hideUi &&
          isData &&
          !isLevelOne &&
          getBeltColor == 'blue' &&
          isIdentifyNoOfLevel == 'two'
      "
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_blue_3_23')"
    ></div>
    <div
      @endSound="finishedIntroSound()"
      :id="isNotEnglish"
      v-if="
      isFirstTimeAppearShVaWithContent &&
        showIntro &&
          !hideUi &&
          isData &&
          !isLevelOne &&
          getBeltColor == 'blue' &&
          (isIdentifyNoOfLevel == 'three' || isIdentifyNoOfLevel == 'four')
      "
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      class="whiteContentfor1"
      v-html="$t('homePageTexts.animationGen_3_24')"
    ></div>
    <div
      @load="imgLoadHandler()"
      :id="isNotEnglish"
      v-if="
      isChooseImagesActive &&
        isShowPics &&
          !showIntro &&
          getBeltColor == 'blue' &&
          (isIdentifyNoOfLevel == 'three' ||
            isIdentifyNoOfLevel == 'four' ||
            isIdentifyNoOfLevel == 'five')
      "
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_white_ChooseOptionOfImage_3_30')"
    ></div>
    <div
    :id="isNotEnglish"
      v-if="
      isChooseImagesActive &&
        isShowPics &&
          !showIntro &&
          getBeltColor == 'blue' &&
          isIdentifyNoOfLevel == 'six'
      "
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_blue_31')"
    ></div>
    <div
      @endSound="finishedIntroSound()"
      @load="imgLoadHandler()"
      :id="isNotEnglish"
      v-if="
      isChooseImagesActive &&
        showIntro &&
          !hideUi &&
          isData &&
          !isLevelOne &&
          getBeltColor == 'blue' &&
          isIdentifyNoOfLevel == 'six'
      "
      style="opacity: 0.5;background: white;color: black;position: absolute;right: 0;bottom: 0;width: 100%; font-size:25px;"
      v-html="$t('homePageTexts.animationGen_white_six_chooseImage_3_26')"
    ></div>

    <div
      class="dev-assist flex flex-column"
      v-if="appConfig.isDevMode || $route.query.dev"
    >
      <button @click="paintVowels">paint a vowel</button>
      {{ vowelToDetect || 'no vowel to detect' }} <br />
      {{ vowelDetectionTime }}
    </div>
    <div class="game-layout">
      <div
        class="text-area"
        v-if="$route.params.level !== appConstants.levelsHash.one"
      >
        <!-- sentence template -->
        <div
          class="word"
          :class="{ paint: correctPicture }"
          v-if="!isSentence() && gameText && gameText.length > 0"
        >
          <div
            class=" flex justify-center"
            v-if="$route.params.level === appConstants.levelsHash.four"
          >
            <span
              class="char"
              :class="{ paint: i + 1 <= charsToPaint }"
              :key="i"
              v-for="(char, i) of textToDisplay"
            >
              <!-- <span :class="handleCharsCssClasses(i)"> -->
              <span>
                {{ char }}
              </span>
            </span>
          </div>
          <span class="char" :class="{ paint: charsToPaint > 0 }" v-else>
            {{ gameText.join('') }}
          </span>
        </div>
        <!-- word template -->
        <div
          class="word flex sentence justify-center"
          :class="{
            'smaller-text': $route.params.level === appConstants.levelsHash.six
          }"
          v-if="isSentence() && gameText && gameText.length > 0"
        >
          <span class="char" :class="{ paint: correctPicture }">
            {{ gameText }}
          </span>
        </div>
      </div>
      <!--  level one pics -->
      <div
        v-if="isLevelOne && levelOnePic"
        class="pics-area word flex justify-center"
      >
        <img class="level-one-pic" :src="getLevelOnePic()" alt="" />
        <img class="level-one-guide-pic" :src="getLevelOneGuidePic()" alt="" />
      </div>
      <!-- pictures selection -->
      <div
        id="pics"
        class="pics flex space-between"
        :class="{ rtl: !picDirection }"
        v-if="isShowPics"
      >
        <div
          class="yes-pic-wrapper pic-wrapper"
          :class="{
            [btnClasses['yesPic']]: true,
            correctPicture,
            loaded: allAssetsLoaded
          }"
        >
          <img
            class="btn fade-in pic yes-pic"
            :class="{ shown: allAssetsLoaded, 'hoverable-button': !showIntro }"
            :src="getGameSelectionPic(gameData.yesPic)"
            handler-id="yesPic"
            @load="imgLoadHandler()"
            @mouseover="handleHoverEvent('yesPic')"
            @mouseout="handleUnhoverEvent('yesPic')"
            @click="handleActivateEventInComponent('yesPic')"
          />
        </div>
        <div
          :class="{ [btnClasses['noPic']]: true, loaded: allAssetsLoaded }"
          class="no-pic-wrapper pic-wrapper"
        >
          <img
            class="btn fade-in pic no-pic"
            :class="{ shown: allAssetsLoaded, 'hoverable-button': !showIntro }"
            :src="getGameSelectionPic(gameData.noPic)"
            handler-id="noPic"
            @load="imgLoadHandler()"
            @mouseover="handleHoverEvent('noPic')"
            @mouseout="handleUnhoverEvent('noPic')"
            @click="handleActivateEventInComponent('noPic')"
          />
        </div>
      </div>
    </div>
    <img
      class="btn back"
      :src="getPic('back')"
      handler-id="back"
      @mouseover="handleHoverEvent('back')"
      @mouseout="handleUnhoverEvent('back')"
      @click="handleActivateBack()"
    />
    <GreatAnimation
      @endGreat="finishedGreatSound()"
      v-if="showGreat"
      curColor="{getBeltColor}"
    />
    <IntroAnimation
      :isPicsIntro="wasPicsIntroShown"
      :levelOf="isIdentifyNoOfLevel"
      @endSound="finishedIntroSound()"
      v-if="showIntro && !hideUi && isData && !isLevelOne"
    />
    <audio ref="success">
      <source src="../assets/sound/correct.wav" type="audio/ogg" />
    </audio>
    <audio ref="noPic">
      <source src="../assets/sound/incorrect.mp3" type="audio/mpeg" />
    </audio>
    <audio ref="wordSound">
      <source :src="getWordSound()" type="audio/ogg" />
    </audio>
  </div>
</template>

<script>
import handHoverMixin from '../mixins/hand-hover-mixin.js';
import GreatAnimation from '@/components/GreatAnimation';
import IntroAnimation from '@/components/IntroAnimation';
import appConstants from '../config/constants';
import appConfig from '../config/config';
import wordsJson from '../config/words.json5';
import util from '../util/app-util';

export default {
  name: 'GameUi',
  components: {
    GreatAnimation,
    IntroAnimation
  },
  mixins: [handHoverMixin],
  props: {
    isData: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      wordsJson,
      appConstants,
      appConfig,
      btnClasses: {
        back: '',
        yesPic: '',
        noPic: ''
      },
      correctPicture: false,
      resolvedAllVowels: false,
      gameData: {},
      gameText: [],
      soundContent: '',
      textToDisplay: '',
      wordBank: [],
      charsToPaint: 0,
      gameStage: 0,
      vowelToDetect: '',
      vowelDetectionTime: 0,
      picDirection: false, // makes the pictures selection change sides randomly
      levelOnePic: null,
      isLevelOne: false,
      showGreat: false,
      showIntro: false,
      vowelDetectionDelay: false,
      wasPicsIntroShown: false,
      isIdentifyNoOfLevel: 0,
      getBeltColor: '',
      isChooseImagesActive: true,
      isChoosenAnswerWords: false,
      isFirstTimeAppearShVaWithContent : true,
      isNotEnglish:localStorage.getItem('selectedLang') && localStorage.getItem('selectedLang')!='en'?'arabictextalign':''
    };
  },
  watch: {
    $route() {
      this.resetComponenetData();
      this.setComponenetData();
    },
    isShowPics(newVal, oldVal) {
      if (newVal && !oldVal) {
        // only reload btns if this value actually changed!
        setTimeout(() => {
          // if (this.resolvedAllVowels) {
          this.$store.getters.getAppRootServices.reloadHoverableButtons();
          // }
        }, 100);
      }
    }
  },
  mounted() {
    this.setComponenetData();
  },
  computed: {
    isShowPics() {
      //isChooseImagesActive ,getBeltColor, isIdentifyNoOfLevel
      return (
        this.gameData.yesPic &&
        this.gameData.noPic &&
        (this.isSentence() || this.resolvedAllVowels) &&
        !this.isLevelOne
      );
    }
  },
  methods: {
    //--------------- componenet related functions ---------------
    errHandler() {
      alert('invalid route');
      this.$router.push(`/belts-selection`);
    },
    resetComponenetData() {
      this.gameStage = 0;
      this.gameText = [];
      this.wordBank = [];
      this.soundContent = [];
      this.resetWordData();
    },
    resetWordData() {
      // reseting this class so hover event can work. unhover event wont work on yesPic after activate event!
      // see handleUnhoverEvent in mixins for more details
      this.btnClasses.yesPic = '';
      this.gameData = {};
      this.correctPicture = false;
      this.resolvedAllVowels = false;
      this.isLevelOne =
        this.$route.params.level === appConstants.levelsHash.one;
      this.vowelToDetect = '';
      this.levelOnePic = '';
      this.charsToPaint = 0;
    },
    setComponenetData() {
      const params = this.$route.params;
      // check first if params are valid. can't continue withut valid params ( belt color and level)!
      if (this.isValidParams(params)) {
        this.isLevelOne = params.level === appConstants.levelsHash.one;
        if (!this.isLevelOne) {
          // no intro for level one
          this.handleIntro(params);
        }
        this.setWordBank(params);
        this.setGameData();
      } else {
        this.errHandler();
      }
    },
    setGameData() {
      if (this.gameStage >= this.wordBank.length) {
        this.levelCompleted();
        return;
      }
      this.gameData = this.wordBank[this.gameStage]; // initially, gameStage will be 0. when student succeeds with a word, it will increment.
      if (this.gameData) {
        this.gameText = this.gameData.gameText;
        let checkSelectedLangFlag = localStorage.getItem('selectedLang')?localStorage.getItem('selectedLang'):'';
        if(checkSelectedLangFlag=='en'){
          this.soundContent = this.gameData.soundContent_english;
        }if(checkSelectedLangFlag=='ar'){
          this.soundContent = this.gameData.soundContent_arabic;
        }if(checkSelectedLangFlag=='ah'){
          this.soundContent = this.gameData.soundContent_default;
        }
        
        this.handleTextToDisplay();
        if (!this.isSentence()) {
          // if gameText is a word (and not a sentence), it must be splitted in order to paint it char by char
          this.gameText = this.gameData.gameText.split('');
          // let checkSelectedLangFlag = localStorage.getItem('selectedLang')?localStorage.getItem('selectedLang'):'';
        if(checkSelectedLangFlag=='en'){
          this.soundContent = this.gameData.soundContent_english;
        }if(checkSelectedLangFlag=='ar'){
          this.soundContent = this.gameData.soundContent_arabic;
        }if(checkSelectedLangFlag=='ah'){
          this.soundContent = this.gameData.soundContent_default;
        }
          // this.soundContent = this.gameData.soundContent;
          // this function is only relevant if gameText is a word (and not sentence)
          this.setVowelToDetect();
        }
        if (this.isLevelOne) {
          this.levelOnePic = this.gameData.noPic;
        }
      } else {
        this.errHandler();
      }
    },
    handleTextToDisplay() {
      this.textToDisplay = this.gameData.gameText;
      // Choose image content active for first time on every steps(game)
      if(this.$route.params.level == this.isIdentifyNoOfLevel){
        this.isChooseImagesActive=false;
        this.isChoosenAnswerWords = false;
      }
      this.isIdentifyNoOfLevel = this.$route.params.level;
      if (this.$route.params.level === appConstants.levelsHash.four) {
        let charArr = [];
        const arr = this.gameText.split('');
        for (let i = 0; i < arr.length; i++) {
          let char = arr[i];
          if (
            util.isCharacterVowel(arr[i + 1]) ||
            (!util.isCharacterVowel(arr[i]) &&
              !util.isCharacterVowel(arr[i + 1]) &&
              util.isCharacterVowel(arr[i + 2]))
          ) {
            char += arr[i + 1];
            i++;
            if (util.isCharacterVowel(arr[i + 1])) {
              char += arr[i + 1];
              i++;
            }
          }
          if (
            !util.isCharacterVowel(arr[i + 1]) &&
            arr[i + 2] &&
            !util.isCharacterVowel(arr[i + 2]) &&
            !util.isCharacterVav(arr[i + 2])
          ) {
            char += arr[i + 1];
            i++;
            if (
              !util.isCharacterVowel(arr[i + 1]) &&
              !util.isCharacterVowel(arr[i + 2])
            ) {
              char += arr[i + 1];
              i++;
            }
          }
          const vav =
            util.isCharacterVav(arr[i + 1]) && util.isCharacterVowel(arr[i]);
          if (
            (util.isChracterShin(arr[i + 1]) &&
              util.isCharacterVowel(arr[i + 2]) &&
              !util.isCharacterVowel(arr[i + 3])) ||
            vav
          ) {
            char += arr[i + 1] + arr[i + 2];
            i += 2;
          }
          if (i + 2 === arr.length && !util.isCharacterVowel(arr[i + 1])) {
            char += arr[i + 1];
            i++;
          }
          charArr.push(char);
        }
        this.textToDisplay = charArr;
      }
    },
    navigateBack() {
      this.$router.push(`/levels-selection/${this.$route.params.beltColor}`);
    },
    handleIntro(/*params*/) {
      // intro is always shown.
      this.showIntro = true;
      // this can be used in order to make the intro shown only in the first belt the user is playing.
      // the app was designed that way initally, so support for this option still exists.
      // params.beltColor === appConstants.white ||
      // this.$store.getters.getFirstTimePlaying;
    },
    //--------------- vowels and camera logic ---------------
    handleActivateEventInComponent(handlerId) {
      if (!this.isShowPics) {
        // if pictures are hidden, no point in responding to activate behavior
        return;
      }
      if (
        handlerId === appConstants.yesPic &&
        // this.lastActivatedBtn !== appConstants.yesPic &&
        !this.correctPicture
      ) {
        this.isChooseImagesActive = false;
        this.isChoosenAnswerWords = true;
        this.correctPicture = true;
        // on correct picture, play the word sound
        this.playComponentsSounds(handlerId, true);
        // setTimeout(() => {
        //   this.nextWordInBank();
        // }, 4000);
      }
      if (
        handlerId === appConstants.noPic &&
        this.lastActivatedBtn !== appConstants.noPic
      ) {
        this.playComponentsSounds(handlerId);
      }
    },
    handleVowelDetected(vowelDetected) {
      if (
        vowelDetected === this.vowelToDetect &&
        !this.showIntro &&
        (this.allAssetsLoaded || this.itemLoaded === 0)
      ) {
        const now = new Date().getTime();
        if (this.vowelDetectionTime === 0) {
          this.vowelDetectionTime = now;
        }
        if (this.vowelDetectionTime <= now - 4000) {
          this.vowelDetectionTime = 0;
        }
        if (!this.vowelDetectionDelay && this.vowelDetectionTime < now - 500) {
          this.vowelDetectionTime = 0;
          this.paintVowels();
          this.handleVowelDetectionDelay();
        }
      }
    },
    handleVowelDetectionDelay() {
      this.vowelDetectionDelay = true;
      setTimeout(() => {
        this.vowelDetectionDelay = false;
      }, appConfig.VOWEL_DETECTION_DELAY);
    },
    getVowelToDetect() {
      return this.vowelToDetect;
    },
    setVowelToDetect() {
      this.vowelToDetect /*: String */ = util.findNextVowel(
        this.charsToPaint,
        this.gameText
      );
    },
    //--------------- game logic ---------------
    setWordBank(params) {
      this.getBeltColor = params.beltColor;
      if (this.isLevelOne) {
        let beltColor = params.beltColor;
        if (params.isWhiteB) {
          beltColor = 'whiteB';
        }
        this.wordBank = this.wordsJson[beltColor][params.level].words;
      } else {
        // only randomize if its NOT level one
        this.wordBank = util.getRandomItems([
          ...this.wordsJson[params.beltColor][params.level].words
        ]);
      }
    },
    nextWordInBank() {
      // setTimeout(() => {
      this.itemLoaded = 0;
      this.allAssetsLoaded = false;
      this.gameStage++;
      this.picDirection = Math.random() > 0.5;
      this.resetWordData();
      this.setGameData();
      // }, 2000);
    },
    levelCompleted() {
      const beltColor = this.$route.params.beltColor;
      let levelToUnlock =
        appConstants.levelsToNumbers[this.$route.params.level] + 1;
      if (levelToUnlock > this.$store.getters.getUnlockedLevels[beltColor])
        this.$store.commit('setUnlockedLevels', {
          levelsToUnlock: levelToUnlock,
          beltColor
        });
      if (this.$route.params.level === appConstants.levelsHash.six) {
        this.$router.push(
          `/animation-generator/${this.$route.params.beltColor}_dance`
        );
        return;
      }
      // this.nextLevel();
      this.navigateBack();
    },
    finishedIntroSound() {
      if(this.showIntro==true){
        this.isFirstTimeAppearShVaWithContent = false;
      }
      this.showIntro = false;
      setTimeout(() => {
        this.$store.getters.getAppRootServices.reloadHoverableButtons();
      }, 100);
    },
    finishedGreatSound() {
      // this.showGreat = false;
      if (
        this.$route.params.beltColor === appConstants.white &&
        !this.$route.params.isWhiteB
      ) {
        this.$router.push(`/animation-generator/whiteB`);
        return;
      }
      // this.navigateBack();
      this.levelCompleted();
    },
    nextLevel() {
      const level = this.$route.params.level;
      const levelIndex = Number(
        appConstants.levelsArr.findIndex(levelFromArr => levelFromArr === level)
      );
      const nextLevel = appConstants.levelsArr[levelIndex + 1];
      if (nextLevel) {
        this.$router.push(`/game/${this.$route.params.beltColor}/${nextLevel}`);
      }
    },
    //--------------- DOM manipulation ---------------
    paintVowels() {
      // debugger;
      const level = this.$route.params.level;
      const { one, two, three, four } = appConstants.levelsHash;
      if (level === one || level === three || level === two) {
        // level 1, 2 and 3 only have 1 vowel, so just paint the whole word.
        while (this.gameText[this.charsToPaint]) {
          this.charsToPaint++;
        }
      }
      if (level === four) {
        // this.handleLevelFourPaintingConditions();
        this.charsToPaint++;
      }
      // this.playComponentsSounds(appConstants.success);
      this.handleIsLastCharInWord();
      this.setVowelToDetect();
    },
    // handleLevelFourPaintingConditions() {
    //   this.charsToPaint++;
    //   while (util.isCharacterVowel(this.gameText[this.charsToPaint])) {
    //     this.charsToPaint++;
    //   }
    //   if (
    //     // first condition: if this char and next char are not vowels, paint the next one too.
    //     (!util.isCharacterVowel(this.gameText[this.charsToPaint]) &&
    //       !util.isCharacterVowel(this.gameText[this.charsToPaint + 1])) ||
    //     // or, this char is not a vowel and the last char in the word
    //     !this.gameText[this.charsToPaint + 1]
    //   ) {
    //     this.charsToPaint++;
    //     // if (!util.isCharacterVowel(this.gameText[this.charsToPaint + 1])) {
    //     //   this.charsToPaint++;
    //     // }
    //   }
    //   if (
    //     //   // next character is ש with nikud
    //     ((util.isChracterShin(this.gameText[this.charsToPaint]) &&
    //       !util.isCharacterVowel(this.gameText[this.charsToPaint + 2])) ||
    //       util.isCharacterVav(this.gameText[this.charsToPaint])) &&
    //     util.isCharacterVowel(this.gameText[this.charsToPaint + 1])
    //     //   // && this.gameText.length <= this.charsToPaint + 2
    //   ) {
    //     this.charsToPaint += 2;
    //   }
    //   if (this.charsToPaint + 1 === this.gameText.length) {
    //     this.charsToPaint++;
    //   }
    // },
    handleIsLastCharInWord() {
      if (this.charsToPaint >= this.textToDisplay.length || this.isLevelOne) {
        if (
          (this.$route.params.level === appConstants.levelsHash.three ||
            this.$route.params.level === appConstants.levelsHash.four) &&
          !this.wasPicsIntroShown
        ) {
          this.showIntro = true;
          this.wasPicsIntroShown = true;
        }
        this.resolvedAllVowels = true;
        const shouldPlayWordSoundAfterSuccess =
          this.$route.params.level === appConstants.levelsHash.two;
        this.playComponentsSounds(
          appConstants.success,
          shouldPlayWordSoundAfterSuccess
        );
        if (this.isLevelOne) {
          // play special sound on level one
          this.levelOnePic = this.gameData.yesPic;
          // if (this.wordBank.length === this.gameStage + 1) {
          //   this.showGreat = true;
          //   return;
          // }
        }
        return;
      }
      this.playComponentsSounds(appConstants.success);
    },
    handleCharsCssClasses(i) {
      const isVavDagesh = isDagesh && util.isCharacterVav(this.gameText[i - 1]);
      const isDagesh = util.isCharacterDagesh(this.gameText[i]);
      const isDageshCorrection =
        isDagesh && util.isCharacterDageshCorrection(this.gameText[i - 1]);
      return {
        'dagesh-vav': isVavDagesh,
        'dagesh-correction': isDageshCorrection
      };
    },
    playSound(sound) {
      try {
        this.$refs[sound].load();
        this.$refs[sound].play();
      } catch (err) {
        // if (this.$refs[sound].onended) {
        //   this.$refs[sound].onended();
        // }
        this.nextWordInBank();
      }
    },
    playComponentsSounds(
      soundType,
      shouldPlayWordSoundAfterSuccess /* Boolean */
    ) {
      // debugger;
      if (
        soundType === appConstants.yesPic ||
        soundType === appConstants.success
      ) {
        this.playSound(appConstants.success);
        if (this.isLevelOne) {
          // this.$refs.success.onended = () => {
          this.$refs.success.onloadeddata = () => {
            setTimeout(() => {
              // this.$refs.success.onended = () => {};
              this.$refs.success.onloadeddata = () => {};
              if (this.wordBank.length === this.gameStage + 1) {
                this.showGreat = true;
                return;
              }
              this.nextWordInBank();
            }, this.$refs.success.duration * 1000);
          };
          return;
        }
        if (shouldPlayWordSoundAfterSuccess) {
          // should only play after correct picture chosen or level 2! (levl 2 doesn't have pictures.);
          // this.$refs.success.onended = () => {
          this.$refs.success.onloadeddata = () => {
            setTimeout(() => {
              this.playComponentsSounds(appConstants.wordSound);
            }, this.$refs.success.duration * 1000);
            // this.$refs.success.onended = () => {};
            this.$refs.success.onloadeddata = () => {};
          };
          return;
        }
      }
      if (soundType === appConstants.noPic) {
        this.playSound(appConstants.noPic);
      }
      // if (soundType === appConstants.wordSound && this.gameData.sound ** this if statment routed to the next word only
      //  when the word sound has been played - which doesnt happen on level 1 **) {
      if (soundType === appConstants.wordSound) {
        this.playSound(appConstants.wordSound);
        // this.$refs.wordSound.onended = () => {
        this.$refs.wordSound.onloadeddata = () => {
          setTimeout(() => {
            this.nextWordInBank();
          }, 500 + this.$refs.wordSound.duration * 1000);
          // }, 500);
        };
        // reset the event handler so it only happens once
        // this.$refs.wordSound.onended = () => {};
        // };
      }
    },
    getWordSound() {
      try {
        return require(`../assets/sound/levels/${
          this.$route.params.beltColor
        }/${this.$route.params.level}/${this.gameData.sound}.mp3`);
      } catch (e) {
        return require('../assets/sound/correct.wav');
      }
    },
    getImgNameExta(handlerId) {
      if (
        this.btnClasses[handlerId] === appConstants.hover ||
        this.btnClasses[handlerId] === appConstants.activate
      ) {
        return '_' + appConstants.hover;
      }
      return '';
    },
    getPic(handlerId) {
      try {
        return require(`@/assets/img/btns/${handlerId}${this.getImgNameExta(
          handlerId
        )}.png`);
      } catch (err) {
        console.warn({ err });
        return require('@/assets/img/btns/no.png');
      }
    },
    getLevelOneGuidePic() {
      let fileName = 'guide_pic';
      if (this.$route.params.isWhiteB) {
        fileName = 'guide_pic_whiteB';
      }
      return require(`@/assets/img/levels/${
        this.$route.params.beltColor
      }/one/${fileName}.png`);
    },
    getLevelOnePic() {
      return require(`@/assets/img/levels/${this.$route.params.beltColor}/one/${
        this.levelOnePic
      }.png`);
    },
    getGameSelectionPic(picName) {
      try {
        return require(`@/assets/img/levels/${this.$route.params.beltColor}/${
          this.$route.params.level
        }/${picName}`);
      } catch (err) {
        console.warn({ err });
        return require('@/assets/img/btns/no.png');
      }
    },
    imgLoadHandler() {
      this.mixinsImgLoadHandler('pics');
      this.$store.getters.getAppRootServices.reloadHoverableButtons();
    },
    //--------------- Boolean functions ---------------
    isSentence() {
      return (
        this.$route.params.level === appConstants.levelsHash.six ||
        this.$route.params.level === appConstants.levelsHash.five
      );
    },
    isValidParams(params) {
      return (
        params &&
        params.beltColor &&
        params.level &&
        ((wordsJson[params.beltColor] &&
          wordsJson[params.beltColor][params.level] &&
          wordsJson[params.beltColor][params.level].words) ||
          // either has data in json or level one
          params.level === appConstants.levelsHash.one)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.dev-assist {
  color: white;
  position: fixed;
  left: 5vw;
  top: 10vh;
}

.back {
  position: absolute;
  width: 14.6%;
  right: 0;
  bottom: 0;
}

.word {
  direction: rtl;
  font-size: 100px;
  font-weight: 600;
  -webkit-text-stroke: 1px white;
  // -webkit-text-stroke: 2px black;
  // text-shadow: 3px 3px 0 white, -1px -1px 0 white, 1px -1px 0 white,
  //   -1px 1px 0 white, 1px 1px 0 white;
}

.char {
  color: black;
  // color: white;
  // removing transition in order to avoid delay when switching word
  transition: none;
  position: relative; // this is for dagesh class!
}

.dagesh-vav {
  position: absolute;
  left: -15px;
}

.dagesh-correction {
  position: absolute;
  left: 17.5px;
}

.paint {
  transition: color 0.3s;
  color: #00ff00;
}

.sentence {
  width: 100%;
  flex-wrap: wrap;
  font-size: 100px;

  &.smaller-text {
    font-size: 65px;
  }
}

.pics {
  position: absolute;
  bottom: 20vh;
}

.pics-area {
  position: relative;
}

.level-one-guide-pic {
  position: absolute;
  left: 1%;
  top: 4%;
  width: 22%;
}

.level-one-pic {
  width: 11%;
}

.pic-wrapper {
  width: 32%;
  // height: 16.9%;
  // margin: 0 5%;
  padding: 10px 10px;
}

.yes-pic-wrapper.loaded {
  &.correctPicture {
    // filter: drop-shadow(0px 0px 10px green);
    background-image: url('../assets/img/btns/correct.png');
    background-size: 98%;
    background-position: center center;
    background-repeat: no-repeat;
  }
  &.hover,
  &:hover {
    // filter: drop-shadow(0px 0px 10px green);
    background-image: url('../assets/img/btns/frame_hover.png');
    background-size: 107%;
    background-position: center center;
    background-repeat: no-repeat;
  }
}

.no-pic-wrapper.loaded {
  &.hover,
  &:hover {
    // filter: drop-shadow(0px 0px 10px green);
    background-image: url('../assets/img/btns/frame_hover.png');
    background-size: 107%;
    background-position: center center;
    background-repeat: no-repeat;
  }
  &.activate {
    // filter: drop-shadow(0px 0px 10px red);
    animation: shake 1s;
    animation-iteration-count: 4s;
  }
}

.rtl {
  direction: rtl;
}
#arabictextalign {
  direction: rtl;
}

@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }
  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }
  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}
</style>
